(function ($) {
    "use strict";

    var $window = $(window);
    var $body = $('body');

    /* Preloader Effect */
    $window.on('load', function(){
        $(".preloader").fadeOut(600);
    });

    /* Sticky Header */
    if($('.active-sticky-header').length){
        $window.on('resize', function(){
            setHeaderHeight();
        });

        function setHeaderHeight(){
            $("header.main-header").css("height", $('header .header-sticky').outerHeight());
        }

        $(window).on("scroll", function() {
            var fromTop = $(window).scrollTop();
            setHeaderHeight();
            var headerHeight = $('header .header-sticky').outerHeight()
            $("header .header-sticky").toggleClass("hide", (fromTop > headerHeight + 100));
            $("header .header-sticky").toggleClass("active", (fromTop > 600));
        });
    }

    // Instagram carousel
    $('.instagram-carousel').each(function () {
        $(this).find('.single-instagram-post')
            .on('auxclick click', function (e) {
                e.preventDefault();
            })
            .on('middleclick', function (e) {
                window.open($(this).attr('data-permalink'));
            });

        $(this).magnificPopup({
            type: 'image',
            delegate: 'a',
            mainClass: 'mfp-fade',
            gallery: {
                enabled: true,
                navigateByImgClick: false,
            },
            removalDelay: 300,
            preloader: false,
            preload: [0, 0],
            fixedContentPos: false,
            callbacks: {
                buildControls: function() {

                    let dots = $("<div class='mfp-dots'></div>");

                    let popup = this;

                    popup._checkIfClose = function(target) {

                        if($(target).hasClass('mfp-prevent-close')) {
                            return;
                        }

                        let closeOnContent = popup.st.closeOnContentClick;
                        let closeOnBg = popup.st.closeOnBgClick;

                        if(closeOnContent && closeOnBg) {
                            return true;
                        } else {

                            // We don't close the popup if click is on navigation dots
                            if($(target).hasClass('mfp-dots') || $(target).hasClass('mfp-dot')) {
                                return false;
                            }

                            // We close the popup if click is on close button or on preloader. Or if there is no content.
                            if(!popup.content || $(target).hasClass('mfp-close') || (popup.preloader && target === popup.preloader[0]) ) {
                                return true;
                            }

                            // if click is outside the content
                            if(  (target !== popup.content[0] && !$.contains(popup.content[0], target))  ) {
                                if(closeOnBg) {
                                    // last check, if the clicked element is in DOM, (in case it's removed onclick)
                                    if( $.contains(document, target) ) {
                                        return true;
                                    }
                                }
                            } else if(closeOnContent) {
                                return true;
                            }

                        }
                        return false;
                    };

                    let children = Object.values(popup.st.items).slice(0, popup.st.items.length);

                    children.forEach((item, index)  => {
                        dots.append("<button type='button' class='mfp-dot' aria-label='post "+index+"' data-index='"+index+"'></button>");
                    });

                    popup.contentContainer.append(dots);
                },
                open: function () {
                    $('body').addClass('mfp-opened mfp-carousel-opened');
                },
                close: function () {
                    $('body').removeClass('mfp-opened mfp-carousel-opened');
                },
                imageLoadComplete: function () {
                    let popup = this;
                    let currItem = popup.currItem;

                    $(currItem.img).on('click middleclick', function () {
                        window.open(currItem.el.attr('data-permalink'));
                    });

                    popup.contentContainer.append(popup.arrowLeft.add(popup.arrowRight));

                    popup.contentContainer.find(".mfp-dots .mfp-dot").removeClass('mfp-dot-active');
                    popup.contentContainer.find(".mfp-dots .mfp-dot[data-index="+currItem.index+"]").addClass('mfp-dot-active');

                    popup.contentContainer.find(".mfp-dots .mfp-dot").on('click', function () {
                        popup.goTo(Number($(this).attr('data-index')));
                        popup.updateItemHTML();
                    });
                }
            }
        })
    });

    /* testimonial Slider JS */
    if ($('.testimonial-slider').length) {
        const testimonial_slider = new Swiper('.testimonial-slider .swiper', {
            slidesPerView : 1,
            speed: 1000,
            spaceBetween: 30,
            loop: true,
            autoplay: {
                delay: 9000,
                disableOnInteraction: true,
                pauseOnMouseenter: true,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.testimonial-button-next',
                prevEl: '.testimonial-button-prev',
            },
            breakpoints: {
                768:{
                    slidesPerView: 1,
                },
                991:{
                    slidesPerView: 1,
                }
            }
        });
    }

    /* Skill Bar */
    if ($('.skills-progress-bar').length) {
        $('.skills-progress-bar').waypoint(function() {
            $('.skillbar').each(function() {
                $(this).find('.count-bar').animate({
                    width:$(this).attr('data-percent')
                },2000);
            });
        },{
            offset: '70%'
        });
    }

    /* Youtube Background Video JS */
    if ($('#herovideo').length) {
        var myPlayer = $("#herovideo").YTPlayer();
    }

    /* Image Reveal Animation */
    if ($('.reveal').length) {
        gsap.registerPlugin(ScrollTrigger);
        let revealContainers = document.querySelectorAll(".reveal");
        revealContainers.forEach((container) => {
            let image = container.querySelector("img");
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    toggleActions: "play none none none"
                }
            });
            tl.set(container, {
                autoAlpha: 1
            });
            tl.from(container, 1, {
                xPercent: -100,
                ease: Power2.out
            });
            tl.from(image, 1, {
                xPercent: 100,
                scale: 1,
                delay: -1,
                ease: Power2.out
            });
        });
    }

    /* Parallaxie js */
    var $parallaxie = $('.parallaxie');
    if($parallaxie.length && ($window.width() > 991))
    {
        if ($window.width() > 768) {
            $parallaxie.parallaxie({
                speed: 0.55,
                offset: 0,
            });
        }
    }

    /* Zoom Gallery screenshot */
    $('.gallery-items').magnificPopup({
        delegate: 'a',
        type: 'image',
        closeOnContentClick: false,
        closeBtnInside: false,
        mainClass: 'mfp-with-zoom',
        image: {
            verticalFit: true,
        },
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: true,
            duration: 300, // don't foget to change the duration also in CSS
            opener: function(element) {
                return element.find('img');
            }
        }
    });

    /* Animated Wow Js */
    new WOW().init();

    /* Popup Video */
    if ($('.popup-video').length) {
        $('.popup-video').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: true
        });
    }

    // Mobile pushy menu
    $window.on("load resize", function () {
        if ($window.width() >= 1199) {
            $('body').removeClass("pushy-open-right");
        }
    })

})(jQuery);
